import styled from "styled-components"
import { colors, radius } from "Shared/tokens"

export const PickerBox = styled.div<{ $accent?: string }>`
  max-height: 100%;
  overflow: auto;
  font-size: 14px;
  padding: 4px;
  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: ${p => p.$accent || colors.gray[600]};
    margin: 0;
    flex: 0 0 auto;
  }
`
export const Row = styled.div<{ depth: number }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  padding-left: ${p => p.depth * 16}px;
`
export const Caret = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  width: 14px;
  padding: 0;
  color: ${colors.gray[500]};
`
export const Empty = styled.div`
  color: ${colors.gray[400]};
  font-size: 12px;
  padding: 8px;
`

// ─── Mode "sélecteur" (dropdown) — aligné sur le filtre "Sélecteur" (dropdownList) ──
export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

// La pastille reprend la logique de bordure du filtre dropdownList : quand `activeBorder`
// est ON, elle applique les réglages tenant (dropdownBorder{Radius,Style,Color,Size}) ;
// sinon une bordure DS discrète. Même contrat de props que les autres filtres.
export const TriggerPill = styled.div<{
  $activeBorder?: boolean
  $borderColor?: string
  $borderSize?: string
  $borderStyle?: string
  $borderRadius?: string
  $bg?: string
  $color?: string
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  box-sizing: border-box;
  height: 100%;
  min-height: 38px;
  padding: 0 8px;
  background: ${p => p.$bg || colors.white};
  color: ${p => p.$color || colors.textPrimary};
  font-size: 14px;
  border-radius: ${p => (p.$activeBorder && p.$borderRadius ? p.$borderRadius : `${radius.default}px`)};
  border: ${p =>
    p.$activeBorder
      ? `${p.$borderSize || "1px"} ${p.$borderStyle || "solid"} ${p.$borderColor || colors.gray[300]}`
      : `1px solid ${colors.gray[300]}`};
`
export const TriggerLabel = styled.span<{ $placeholder?: boolean }>`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* placeholder à l'identique du Sélecteur (react-select) : atténué + italique ;
     valeur sélectionnée : hérite la couleur (auto-contrastée) de la pastille */
  color: ${p => (p.$placeholder ? colors.gray[400] : "inherit")};
  font-style: ${p => (p.$placeholder ? "italic" : "normal")};
`
export const ClearBtn = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;
  padding: 0 2px;
  &:hover {
    opacity: 1;
  }
`
export const TriggerCaret = styled.i`
  color: inherit;
  opacity: 0.7;
`
export const DropdownPanel = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  max-height: 260px;
  overflow: auto;
  background: ${colors.white};
  border: 1px solid ${colors.gray[300]};
  border-radius: ${radius.default}px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  padding: 4px;
`
